import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import stores from './store';
import './theme/index.scss';
import { PersistGate } from 'redux-persist/integration/react';
import Navigation from './navigation';
import { LoadScript } from '@react-google-maps/api';
import { GOOGLE_MAP_API_KEY } from './map/constants';
import { init, ErrorBoundary } from '@sentry/react';

//initialize sentry
init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENVIRONMENT,
});

const { store, persistedStore } = stores;

function FallbackComponent() {
    return <div>An error has occured</div>;
}

// Intro component
function App() {
    return (
        <LoadScript
            id="litter-map-script"
            googleMapsApiKey={GOOGLE_MAP_API_KEY}
        >
            <ErrorBoundary fallback={FallbackComponent}>
                <Navigation />
            </ErrorBoundary>
        </LoadScript>
    );
}

// ReactDOM.render function to render the app itself
render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistedStore}>
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById('root'),
);
